module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn ml-4 bg-dark",
    on: {
      "click": _vm.openLocationManager
    }
  }, [_vm._v("Manage locations")]), _vm._v(" "), _c('button', {
    staticClass: "btn ml-3",
    attrs: {
      "disabled": _vm.routeType == 3
    },
    on: {
      "click": function($event) {
        return _vm.addRoute(_vm.routeType)
      }
    }
  }, [_vm._v("+ New List")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fba5bf90"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/transports/TopButtons.vue
// module id = 2625
// module chunks = 0